import fs from "fs";
import path from "path";
export const prebuildRedirect = async (fetch) => {
    const json = await fetch();
    console.log(`Start write Prismic redirects to file, length: ${Object.keys(json).length}`);
    fs.writeFileSync(path.resolve() + "/public/prismic-redirect.json", JSON.stringify(json));
    console.log(`Write Prismic redirects success`);
};
